import { createNamespacedHelpers } from 'vuex';
import respUtility from './respUtility';

const { mapState, mapMutations } = createNamespacedHelpers('listing');

export default {
  mixins: [respUtility],
  computed: {
    ...mapState(['currentSort']),
    isBrandPage() {
      return this.$store.state.pageData.globalType === 'BRAND';
    },
    isCollectionPage() {
      return this.$store.state.pageData.globalType === 'COLLECTION';
    },
  },
  methods: {
    ...mapMutations([
      'setSelected',
    ]),
    formatFacets(selected) {
      if (!(selected && typeof selected === 'object')) {
        return {};
      }
      const formatted = {};
      const keys = Object.keys(selected.selected);
      keys.forEach((key) => {
        formatted[key] = selected.selected[key].map((item) => item.attrValue);
        if (formatted[key] && !Object.keys(formatted[key]).length) {
          delete formatted[key];
        }
        if (Array.isArray(formatted[key])) {
          if (key === 'price') {
            formatted[key].sort((a, b) => {
              const pricesA = a.split('-');
              const pricesB = b.split('-');
              if (pricesA.length && pricesB.length) {
                return Number(pricesA[0]) - Number(pricesB[0]);
              }
              return 0;
            });
          } else {
            formatted[key].sort();
          }
        }
      });
      if (formatted.collection_type && !formatted.brand
        && !this.$store.state.pageData.globalType === 'BRAND'
      ) {
        delete formatted.collection_type;
        const copy = { ...this.$store.state.listing.currentSelected.selected };
        delete copy.brand;
        delete copy.collection_type;
        this.setSelected(copy);
      }
      if (selected.customPrice && selected.customPrice.attrValue) {
        formatted.price = [selected.customPrice.attrValue];
      }
      return Object.keys(formatted).sort().reduce((obj, key) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = formatted[key];
        return obj;
      }, {});
    },
    changeRouteFacets(selected, slug = '', page = 1) {
      if (this.filtersFromRoute && JSON.stringify(selected)
        === JSON.stringify(this.filtersFromRoute) && !this.$store.state.listing.extensionFilters) {
        if (!(this.$device.isMobileOrTablet || this.isTouchDevice)
            || this.currentSort === this.$store.state.listing.searchParams.sort) {
          return;
        }
      }
      const formatted = this.formatFacets(selected);
      Object.keys(formatted).forEach((key) => {
        if (Array.isArray(formatted[key])) {
          formatted[key] = formatted[key].join('$,$');
        }
      });
      const query = {
        ...this.getRouteParamsExcludeFacets(),
        ...formatted,
        ...(this.$store.state.listing.extensionFilters || {}),
      };
      if (this.currentSort && (this.$device.isMobileOrTablet || this.isTouchDevice)) {
        query['sort-by'] = this.currentSort.toLowerCase();
      }
      if (!this.currentSort) {
        delete query['sort-by'];
      }
      if (!Object.keys(formatted).length) {
        delete query.facet;
      }
      if (query.page) {
        if (this.$store.state.listing.extensionFilters) {
          if (this.catalogSearch.pages < this.catalogSearch.page) {
            query.page = 1;
          }
        } else {
          query.page = 1;
        }
      }
      if (page !== 1) {
        if (query.page) delete query.page;
        query.page = page;
      }

      if (this.$store.state.pageData.type === 'search') {
        query.q = this.$store.state.listing.searchParams.text;
      }
      this.$router.push({
        path: slug || this.$store.state.genuineSlug,
        query,
      });
    },
    getRouteParamsExcludeFacets() {
      const result = {};
      const keys = ['sort-by', 'page', 'per-page'];
      keys.forEach((k) => {
        if (this.$route.query[k]) {
          result[k] = this.$route.query[k];
        }
      });
      return result;
    },
    resetFilters() {
      const { perPage, text } = this.$store.state.listing.searchParams;
      const query = {};
      if (this.$store.state.pageData.type === 'search') {
        query.q = text;
      }
      if (this.$vuetify.breakpoint.mdAndUp && perPage) {
        query['per-page'] = perPage.toLowerCase();
      }
      const route = {
        path: this.$store.state.genuineSlug,
        query: {
          ...query,
          ...(this.$store.state.listing.extensionFilters || {}),
        },
      };
      if (process.server) {
        this.$nuxt.context.redirect(302, route);
        return;
      }
      this.$router.push(route);
    },
    checkSelectedChanged(selectedItems, old) {
      if (!(selectedItems && old)) {
        return true;
      }
      if (selectedItems.length !== old.length) {
        return true;
      }
      if (JSON.stringify(selectedItems) === JSON.stringify(old)) {
        return false;
      }
      let isChanged = false;
      selectedItems.every((item) => {
        if (!old.some((i) => {
          const v1 = i?.attrValue || i;
          const v2 = item?.attrValue || item;
          return v1 === v2;
        })) {
          isChanged = true;
          return false;
        }
        return true;
      });
      return isChanged;
    },
    checkFiltersSelectedChanged(selected, old) {
      const data = selected || {
        selected: {},
        customPrice: null,
      };
      if (JSON.stringify(data) === JSON.stringify(old)) {
        return false;
      }
      const oldSelected = old && old.selected ? old.selected : {};
      const oldCustomPrice = old ? old.customPrice : null;
      const keys = Object.keys(data.selected);
      let isGlobalChanged = keys.length !== Object.keys(oldSelected).length;
      keys.every((attrCode) => {
        const isChanged = this.checkSelectedChanged(data.selected[attrCode], oldSelected[attrCode]);
        if (isChanged) {
          isGlobalChanged = true;
          return false;
        }
        return true;
      });
      return isGlobalChanged || JSON.stringify(data.customPrice) !== JSON.stringify(oldCustomPrice);
    },
  },
};
